import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'

@InputType()
export class UpdateStatusByTasksArgs extends ActionArgs {
  @Field(() => String)
  projectId: string
}

export interface IUpdateStatusByTasks extends IAction<void, UpdateStatusByTasksArgs> {}
